import { createAsyncThunk } from '@reduxjs/toolkit';

const onFetchTimeSeries = async (
  { timeRange, filter },
  { extra: { http } }
) => {
  const { recruiters } = filter;
  const params = {
    filter_by: { time_range: {} },
  };

  if (timeRange) {
    params['filter_by']['time_range']['from_ts'] = timeRange?.from;
    params['filter_by']['time_range']['to_ts'] = timeRange?.to;
    params['filter_by']['time_range']['interval'] = timeRange?.defaultInterval;
  }

  if (recruiters) {
    params['filter_by']['users'] = recruiters;
  }

  try {
    const result = await http.get(`outreach_dashboard/timeseries`, {
      params,
    });
    return result;
  } catch {}
};

const onFetchGroupByOutreach = async (
  { filter, page },
  { extra: { http } }
) => {
  const { ids } = filter;

  const params = {
    filter_by: {},
  };

  if (ids) {
    params['filter_by']['ids'] = ids;
  }

  try {
    const result = await http.get(
      `outreach_dashboard/all_outreaches?page=${page}`,
      {
        params,
      }
    );
    return result;
  } catch {}
};

const onFetchGroupBySender = async ({ filter, page }, { extra: { http } }) => {
  const { senders } = filter;

  const params = {
    filter_by: {},
  };

  if (senders) {
    params['filter_by']['users'] = senders;
  }
  try {
    const result = await http.get(`outreach_dashboard/senders?page=${page}`, {
      params,
    });
    return result;
  } catch {}
};

const onFetchAllOutreaches = async ({ page }, { extra: { http } }) => {
  try {
    const result = await http.get(`outreaches/list/all`);
    return result;
  } catch {}
};

export const fetchTimeSeries = createAsyncThunk(
  'dashboardOutreach/timeSeries',
  onFetchTimeSeries
);

export const fetchGroupByOutreach = createAsyncThunk(
  'dashboardOutreach/groupByOutreach',
  onFetchGroupByOutreach
);

export const fetchGroupBySender = createAsyncThunk(
  'dashboardOutreach/groupBySenders',
  onFetchGroupBySender
);

export const fetchAllOutreaches = createAsyncThunk(
  'dashboardOutreach/fetchAllOutreaches',
  onFetchAllOutreaches
);
